const LOGGED_OUT_HOLDOUTS = {} as const satisfies Record<string, string>;
const TEACHER_HOLDOUTS = {
  HOLDOUT_VIEIRA_TEACHER_FIRST_HOLDOUT: "holdout_vieira_teacher_first_holdout",
} as const satisfies Record<string, string>;

export const ExternalSwitches = {
  WEB_ATTRIBUTION_SURVEY: "web_attribution_survey_v2",
  WEB_EXTERNAL_DOJO_ISLANDS_PLAY_NOW: "web_external_dojo_islands_play_now",
  WEB_EXTERNAL_DOJO_ISLANDS_ALLOW_PHONE_SUBMISSION: "web_external_dojo_islands_allow_phone_login",
  WEB_JOURNEY_SPARKS_TEST_MODAL: "web_journey_sparks_test_mode",
  WEB_EXTERNAL_TEACH_SSO_SIGNUP_OPTION_V1: "web_external_teach_sso_signup_option_v1",
  ...LOGGED_OUT_HOLDOUTS,
} as const;

export const LiteSwitches = {
  WEB_LITE_REDIRECT_EMAIL_VERIFICATION: "web_lite_redirect_email_verification_v3",
} as const;
export const TeacherSwitches = {
  WEB_TEACHER_VIEIRA_CLIENT_1: "web_teacher_vieira_client_1",
  WEB_TEACHER_VIEIRA_CLIENT_2: "web_teacher_vieira_client2",
  ...TEACHER_HOLDOUTS,
} as const;

export const featureSwitches = Object.values({ ...ExternalSwitches, ...TeacherSwitches, ...LiteSwitches });
export type FeatureSwitch = Exclude<
  (typeof featureSwitches)[number],
  | (typeof LOGGED_OUT_HOLDOUTS)[keyof typeof LOGGED_OUT_HOLDOUTS]
  | (typeof TEACHER_HOLDOUTS)[keyof typeof TEACHER_HOLDOUTS]
>;
export const defaultFSValues = featureSwitches.reduce((acc, fs) => ({ ...acc, [fs]: "off" }), {});
